var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content"},[(_vm.$mq != 'sm')?_vm._t("breadcrumbs"):_vm._e(),_vm._v(" "),(_vm.enableHeader)?_c('header',[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"table-view__notifications"},[_vm._t("notifications")],2),_vm._v(" "),_c('main',[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }